<template>
  <confirm-dialog ref="dialog" ok-text="Confirm" :width="60" :hasFooter="true" :confirm-cb="readyShipmentCb"
    :title="'Ready Shipment ' + shipmentNo" :loading="loading">
    <template v-slot:content>
      <div class="f-r header">
        <div class="common-hint-list header-left">
          <span> 1. Please CHECK loaded pallets before confirm </span>
          <span> 2. Can NOT modify shipment after Ready! </span>
          <span> 3. Left Over pallets will be removed from shipment. </span>
          <span> 4. Seal No. will be required if not provided! </span>
          <span> 5. PickUp No. will be required if not provided! </span>
          <span> 6. EST Delivery Date. will be required if not provided! </span>
        </div>
        <div class="header-right f-c">
          <div class="input-item f-r-c-sb" v-for="item in readyForm" :key="item.key">
            <span class="label">{{ item.label }}</span>
            <div class="f-c">
              <el-date-picker v-if="item.type === DateSelect" size="medium" v-model="item.value" type="date"
                placeholder="Select date" :format="TimeFormat" />
              <el-input v-else size="medium" v-model="item.value" />
              <span class="error-hint">
                {{ formErrors[item.key] }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="pallets-list">
        <el-tabs v-model="selectedTab">
          <el-tab-pane label="Left Over Pallets" name="lefts">
            <pallet-list :maxHeight="tableMaxHeight" :showHeaderOps="false" :showLabelAction="false" class="pallet-list"
              :palletQuery="leftOverPalletIds.length > 0 ? { ids: leftOverPalletIds } : null
                " :excludeCols="['hold', 'slotNo', 'priority']">
              <template v-slot:actions="props">
                <el-button size="small" type="text" class="danger-text" @click="removePallet(props.row)">
                  Remove
                </el-button>
              </template>
            </pallet-list>
          </el-tab-pane>
          <el-tab-pane label="Loaded Pallets" name="loaded">
            <pallet-list :maxHeight="tableMaxHeight" :showHeaderOps="false" :showLabelAction="false" class="pallet-list"
              :palletQuery="loadedPalletIds.length > 0 ? { ids: loadedPalletIds } : null
                " :excludeCols="['hold', 'slotNo', 'priority', 'status']">
              <template v-slot:actions="props">
                <el-button size="small" type="text" class="danger-text" @click="removePallet(props.row)">
                  Remove
                </el-button>
              </template>
            </pallet-list>
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>
  </confirm-dialog>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import { DateSelect, TextInput, TimeFormat } from '@/core/configs/types'
// components
import ConfirmDialog from '@/components/common/Confirm.vue'
import PalletList from '@/components/pallet/PalletList.vue'
// models
import { ShipmentReadyForm } from '@/core/models/shipment'
import {
  detailShipment,
  modifyShipmentPallets,
  readyShipment
} from '@/api/shipment'
import PagesMessage from '@/core/message/pages'
// message
// import PagesMessage from '@/core/message/pages'
export default {
  name: 'ReadyShipment',
  components: {
    ConfirmDialog,
    PalletList
  },
  data() {
    return {
      DateSelect,
      TextInput,
      TimeFormat,
      loading: false,
      shipmentNo: '',
      shipmentDetail: null,
      readyForm: cloneDeep(ShipmentReadyForm),
      formErrors: {},
      selectedTab: 'lefts',
      portSelected: '',
      callback: null
    }
  },
  computed: {
    shipmentId() {
      return this.shipmentDetail?.id ?? ''
    },
    leftOverPalletIds() {
      const loaded = this.loadedPalletIds
      const allIds = this.shipmentDetail?.palletIds ?? []
      return allIds.filter(function (x) {
        return loaded.indexOf(x) < 0
      })
    },
    loadedPalletIds() {
      return this.shipmentDetail?.loadedPalletIds ?? []
    },
    tableMaxHeight() {
      return window.innerHeight - 300
    }
  },
  methods: {
    async open(shipmentNo, cb = null) {
      this.shipmentNo = shipmentNo
      this.loadShipmentDetail()
      this.$set(this, 'formErrors', {})
      this.$refs.dialog.open()
      this.callback = cb
    },
    reset() {
      this.readyForm = cloneDeep(ShipmentReadyForm)
      this.readyForm[0].value = this.shipmentDetail.pickUpNo
      this.readyForm[1].value = this.shipmentDetail.trailerNo
      this.readyForm[2].value = this.shipmentDetail.sealNo
    },
    async loadShipmentDetail() {
      this.loading = true
      const shipment = await detailShipment(this.shipmentNo)
      if (!shipment) {
        this.$message.error('Failed to get shipment data!')
        this.$refs.dialog.close()
        return
      }
      this.shipmentDetail = shipment
      this.reset()
      this.loading = false
    },
    readyShipmentCb(done, error) {
      this.$set(this, 'formErrors', {})
      // check pick up and some other required
      if (!this.readyForm[0].value) {
        this.formErrors[this.readyForm[0].key] = 'Pick up no is required!'
        return
      }
      if (!this.readyForm[1].value) {
        this.formErrors[this.readyForm[1].key] = 'Trailer no is required!'
        return
      }
      const form = Object.fromEntries(
        this.readyForm.map(one => [one.key, one.value])
      )
      form.id = this.shipmentId
      this.loading = true
      this.$confirm(
        'All unloaded pallets will be deleted from shipment, continue',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          readyShipment(form)
            .then(() => {
              this.$message.success('Successful!')
              done()
              if (this.callback) this.callback()
            })
            .catch(err => {
              error(err.toString())
            })
        })
        .catch(() => { })
    },
    removePallet(pallet) {
      this.loading = true
      this.$confirm(
        `Remove pallet ${pallet.no} from ${this.shipmentNo}`,
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          modifyShipmentPallets(this.shipmentId, [], [pallet.id])
            .then(() => {
              // refresh the page
              this.loadShipmentDetail()
              PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_DETAIL)
            })
            .catch(() => {
              this.$message.error('Failed to remove pallet from shipment!')
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => { })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.input-item {
  padding: 0 1px;
  margin-bottom: 10px;

  div {
    span {
      font-size: 11px;
      color: $el-danger-color;
    }

    width: 60%;
  }

  .el-input {
    width: 100%;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}

.header {
  gap: 20px;

  .header-left {
    width: 60%;
  }

  .header-right {
    width: 40%;
  }

  .common-hint-list {
    margin-bottom: 0;
    font-size: 18px;
  }
}
</style>
